import { render, staticRenderFns } from "./addFollowUp.vue?vue&type=template&id=b200285a&"
import script from "./addFollowUp.vue?vue&type=script&lang=js&"
export * from "./addFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./addFollowUp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports